<template>
  <div class="banner-password-login">
    <h2 class="login-title">密码登录</h2>
    <div class="title-line"></div>
    <el-form ref="passwordLogin" :model="ruleForma" :rules="rules" class="password-form">
      <el-form-item prop="username">
        <el-input v-model.trim="ruleForma.username" placeholder="请输入账号" @input="accountVerify" />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model.trim="ruleForma.password"
          type="password"
          placeholder="请输入密码"
          @input="passwordVerify"
          @keyup.enter.native="submitAntiShaking"
        />
      </el-form-item>
    </el-form>
    <el-button
      class="login-submit"
      :loading="loading"
      :disabled="loginBgColor"
      @click="submitAntiShaking"
    >登录</el-button>
  </div>
</template>

<script>
import newLogin from "@/views/login/newLogin.vue";

export default {
  name: "BannerPasswordLogin",
  // 导航和横幅入口共用展示，复用原组件的校验、接口、登录缓存和刷新流程。
  extends: newLogin,
  data() {
    // 此密码登录入口无需协议确认，表单校验及登录流程继续复用原组件。
    return { a: 1, requirePasswordAgreement: false };
  },
};
</script>

<style lang="less" scoped>
.banner-password-login {
  box-sizing: border-box;
  min-height: 384px;
  padding: 36px 28px 40px;
  color: #444;
  background: #f1f4ff;

  .login-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 25px;
    text-align: center;
  }

  .title-line {
    width: 28px;
    height: 3px;
    margin: 8px auto 28px;
    background: #1d7df5;
    border-radius: 2px;
  }

  .password-form {
    /deep/ .el-form-item {
      // 每个输入框下预留校验提示空间，避免错误文字贴住下一项。
      margin-bottom: 32px;
    }

    /deep/ .el-form-item__error {
      padding-top: 6px;
      line-height: 16px;
    }

    /deep/ .el-input__inner {
      height: 44px;
      padding: 0 16px;
      background: #fff;
      border: 1px solid transparent;
      border-radius: 8px;
      font-size: 14px;

      &:focus {
        border-color: #1d7df5;
      }
    }
  }

  .login-submit {
    width: 100%;
    height: 44px;
    margin-top: 28px;
    padding: 0;
    color: #fff;
    background: #1d7df5;
    border-color: #1d7df5;
    border-radius: 8px;
    font-size: 16px;

    &:not(.is-disabled):hover,
    &:not(.is-disabled):focus {
      background: #1670df;
      border-color: #1670df;
    }

    &.is-disabled {
      color: #fff;
      background: #1d7df5;
      border-color: #1d7df5;
    }
  }
}
</style>
